<template>
  <div class="input">
    <label v-if="label" for="range-input">{{ label }}</label>

    <div class="d-flex range-input">
      <a-tooltip :mouseEnterDelay="0" :mouseLeaveDelay="0" :title="minTitle" placement="bottom">
        <input id="range-input" :value="min" type="number" class="form-control pass-input" :placeholder="minTitle"
             style="min-width: 100px; max-width: 140px; border-bottom-right-radius: 0; border-top-right-radius: 0;"
             min="18" max="100"
             @change="emitEvent('min', $event.target.value)"
      />
      </a-tooltip>

      <a-tooltip :mouseEnterDelay="0" :mouseLeaveDelay="0" :title="maxTitle" placement="bottom">
        <input :value="max" type="number" class="form-control pass-input" :placeholder="maxTitle"
             style="min-width: 100px; max-width: 140px; border-bottom-left-radius: 0; border-top-left-radius: 0;"
             min="18" max="100"
             @change="emitEvent('max', $event.target.value)"
      />
      </a-tooltip>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    label: {
      type: String,
      default: '',
    },

    minTitle: {
      type: String,
      default: 'Min.',
    },

    maxTitle: {
      type: String,
      default: 'max.',
    },
  },

  data() {
    return {
      min: 18,
      max: 100,
    };
  },

  methods: {
    emitEvent(evtName, value) {
      if (evtName === 'min') {
        this.min = parseInt(value);

        if (this.min >= 100) {
          this.min = 99;
        }

        if (this.min >= this.max) {
          this.max = this.min + 1;
        }

        if (this.min < 18) {
          this.min = 18;
        }
      } else {
        this.max = parseInt(value);

        if (this.max <= this.min) {
          this.max = this.min + 1;
        }

        if (this.max > 100) {
          this.max = 100;
        }
      }

      this.$emit('min', this.min);
      this.$emit('max', this.max);
    },
  },
};
</script>
